// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__9BIJ2","image":"App_image__3B9Hw"};